import React, { FC } from 'react';

import { TotalPriceBlockProps } from './types';
import { Amount, Discount, NextDate } from './components';

import styles from './index.module.scss';

const TotalPriceBlock: FC<TotalPriceBlockProps> = ({
  currentPeriod,
  selectedPriceItemPeriodId,
  selectedPriceItemPeriodTitle,
}) => (
  <div>
    <span className={styles.totalPriceBlock}>
      <Amount
        selectedPriceItemPeriodId={selectedPriceItemPeriodId}
        currentPeriodId={currentPeriod?.id}
      />

      {currentPeriod?.id === selectedPriceItemPeriodId && <Discount />}
    </span>

    <NextDate selectedPriceItemPeriodTitle={selectedPriceItemPeriodTitle} />
  </div>
);

export default React.memo(TotalPriceBlock);
